import store from ".";

const getters = {
    isAuth(state) {
        return !!state.user_id;
    },
    get_user_level(state) {
        return state.user_level;
    },
    get_item_info(state) {
        return state.item_info;
    },
    get_post_template_info(state) {
        return state.post_template_info;
    },
    get_gms_server_type(state) {
        return state.gms_server_type;
    },
    get_gms_server_name(state) {
        return state.gms_server_name;
    },
    gms_const_refresh_flag(state) {
        return state.const_refresh_flag;
    },
    get_category_info(state) {
        return state.category_list;
    },
    get_title_info(state) {
        return state.title_list;
    },
    get_gms_const_info(state) {
        return state.const;
    },
 
    
    valid_admin_level(state) {
        if( state.gms_server_type  === null ) return false;
        if( state.gms_server_type === 1) return state.user_level >= 1;
        if( state.gms_server_type === 2 || state.gms_server_type === 4 ) return state.user_level >= 5;
        if( state.gms_server_type === 3) return state.user_level >= 10;
        return false;
    },
    get_selected_game_package (state)
    {
        return state.selected_game_package;
    },
    get_selected_ad_os (state)
    {
        return state.selected_ad_os;
    },
    get_selected_ad_language (state)
    {
        return state.selected_ad_language;
    },
    get_selected_game_server(state)
    {
        return state.selected_game_server;
    }


}

export default getters;